import { render, staticRenderFns } from "./popup-account-password.vue?vue&type=template&id=b88665ee&scoped=true&"
import script from "./popup-account-password.vue?vue&type=script&lang=js&"
export * from "./popup-account-password.vue?vue&type=script&lang=js&"
import style0 from "./popup-account-password.vue?vue&type=style&index=0&id=b88665ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88665ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VTextField})
